import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

import Close from '../../../../global/icons/Close';

import {
  CloseSurface,
  CloseWrapper,
  Image,
  ImageSubWrapper,
  Label,
  LabelWrapper,
  Screen,
  Wrapper
} from './components';

const Lightbox = ({ label, onClose = () => {}, src, theme }) => (
  <Screen>
    <CloseSurface onClick={onClose} />
    <Wrapper>
      <CloseWrapper>
        <Close fill={theme.color.headerPrimary} size={25} click={onClose} />
      </CloseWrapper>
      <ImageSubWrapper>
        <Image src={src} alt={label} />
      </ImageSubWrapper>
      <LabelWrapper>
        <Label>{label}</Label>
      </LabelWrapper>
    </Wrapper>
  </Screen>
);

Lightbox.propTypes = {
  label: PropTypes.string,
  onClose: PropTypes.func,
  src: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired
};

export default withTheme(Lightbox);
